import classNames from "classnames";
import React, { PropsWithChildren } from "react";

interface ToolTipProps extends PropsWithChildren {
  /** Name is used in the input elements id and labels elements for values to create a unique label + input pair. If the name is not unique it will cause tooltip components to trigger each others content display when clicked. */
  name: string;
  /** When true will reverse out the icons colour to work against dark backgrounds. */
  inverted?: boolean;
  /** When true will render the tooltip inline along side other content such as text. */
  inline?: boolean;
  /** Changes the alignment of the tooltips content when displayed. */
  contentAlignment?: "right" | "left" | "bottom-right" | "bottom-left";
  /** When true, customises the tooltips content element for more appropriate display when being used as a menu. */
  menu?: boolean;
}

export const Tooltip: React.FC<ToolTipProps> = ({
  name,
  inverted,
  inline,
  contentAlignment,
  menu,
  children,
}) => {
  const tooltipClasses = classNames("tooltip", {
    "tooltip--inverse": inverted,
    "tooltip--inline": inline,
    "tooltip--menu": menu,
  });
  return (
    <div
      title="tooltip"
      className={tooltipClasses}
      data-alignment={contentAlignment}
    >
      <input
        type="checkbox"
        id={`tooltip__trigger-${name}`}
        className="tooltip__trigger"
      />
      <label
        htmlFor={`tooltip__trigger-${name}`}
        className="tooltip__trigger-icon"
      >
        <span className="tooltip__trigger-label-text">More information</span>
      </label>
      <div className="tooltip__content">{children}</div>
    </div>
  );
};
